import { CreditsPermission } from '@idc-forms/permissions'
import type { RouteObject } from 'react-router'
import { PATHS } from '@/app/router/routes'
import { ProtectedRoute } from '@/shared/components/protected-route'

export const creditsRoutes: RouteObject[] = [
  {
    element: (
      /*
       * CUALQUIERA de los dos permisos de consulta abre la pantalla; el ALCANCE —tu cartera contra
       * todas— lo decide el servidor. Es la misma puerta que declara la API (`CREDIT_READ_ACCESS`).
       *
       * Con `ReadAllCredits` solo, el asesor que ve su propia cartera caía en «no autorizado» sobre
       * una pantalla que sí tiene derecho a abrir. Y con `ReadCredits` solo, un rol al que un
       * administrador le tildó «Consultar todos» y nada más quedaba afuera de una pantalla que la
       * API sí le sirve — que se lee como un frontend roto, no como una casilla faltante. La
       * pantalla de roles reparte a mano, así que ese estado se puede pedir en cualquier momento.
       *
       * ⚠️ El ítem del menú (`nav-main.tsx`) declara los MISMOS permisos, y tienen que viajar
       * juntos: si divergen, o hay un link a una pantalla que redirige, o una pantalla sin forma de
       * llegar.
       */
      <ProtectedRoute
        permission={[CreditsPermission.ReadCredits, CreditsPermission.ReadAllCredits]}
        redirectTo={PATHS.admin.unauthorized}
      />
    ),
    children: [
      {
        index: true,
        lazy: {
          Component: () => import('./pages/credits.page').then((module) => module.CreditsPage)
        }
      },
      {
        path: ':id',
        lazy: {
          Component: () =>
            import('./pages/credit-expedient.page').then((module) => module.CreditExpedientPage)
        }
      }
    ]
  }
]
